import styled from 'styled-components'

import { ClinTheme } from '../../../ClinTheme'
import { mediaQuery } from '../../../utils/mediaQuery'

export interface IStyledAutoSuggestResultItemProps {
  /** Show highlight styles */
  selected?: boolean
  /** Add border radious on last li element for suggestions */
  borderRadiusLastLiElement?: string
  /** Optional parametar padding for suggestion text*/
  suggestionTextPadding?: string
  /** Whether this AutoSuggest is used in header context (affects styling) */
  isHeader?: boolean
}

export interface IStyledSectionHeaderProps {
  /** Whether this is the first section header in the list */
  isFirstSection?: boolean
}

const desktopUpBreakpoint = ClinTheme.breakpoints[2]

export const StyledAutoSuggestWrapper = styled.div({
  flex: '1 1 auto'
})

export const StyledAutoSuggestResultItem =
  styled.li<IStyledAutoSuggestResultItemProps>(
    {
      fontSize: ClinTheme.fontSizes[3],
      fontWeight: ClinTheme.fontWeights.light,
      color: ClinTheme.colors.primary,
      backgroundColor: ClinTheme.colors.white,
      margin: '8px',
      border: '1px solid transparent',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: 'pointer',
      [`a`]: {
        display: 'block',
        color: ClinTheme.colors.primary
      },
      [`:hover, :focus`]: {
        border: `1px solid ${ClinTheme.colors.lightGrey}`,
        boxShadow: '0px 0px 8px -6px rgba(0,0,0,0.75)'
      },
      [`:last-child`]: {
        display: 'flex',
        justifyContent: 'center',
        margin: '0',
        lineHeight: `${ClinTheme.space[4]}px`,
        padding: `${ClinTheme.space[2]}px 0 ${ClinTheme.space[3]}px`,
        backgroundColor: ClinTheme.colors.lightGrey,
        borderRadius: ClinTheme.radii[2],
        [`:hover, :focus`]: {
          border: `1px solid ${ClinTheme.colors.lightGrey}`,
          boxShadow: 'none'
        }
      }
    },
    ({ selected }) => ({
      backgroundColor: selected
        ? ClinTheme.colors.lightGrey
        : ClinTheme.colors.white
    }),
    ({ suggestionTextPadding, isHeader }) => {
      if (isHeader) {
        return { padding: '0' } // Remove padding for header context
      }
      const paddingValue =
        suggestionTextPadding ||
        `${ClinTheme.space[2]}px ${ClinTheme.space[3]}px`
      return { padding: paddingValue }
    }
  )
export const StyledLinkWithIcon = styled.div({
  display: 'flex',
  alignItems: 'center',
  color: ClinTheme.colors.tealishBlue,
  justifyContent: 'center',
  cursor: 'pointer'
})
export const StyledAlternativesText = styled.div({
  display: 'flex',
  alignItems: 'center',
  color: ClinTheme.colors.black,
  fontSize: ClinTheme.fontSizes[2],
  backgroundColor: ClinTheme.colors.white,
  borderTopLeftRadius: ClinTheme.radii[3],
  borderTopRightRadius: ClinTheme.radii[3],
  margin: '0',
  padding: `${ClinTheme.space[3]}px`
})
export const StyledNoResults = styled.div({
  cursor: 'pointer'
})

export const StyledSectionHeader = styled.li<IStyledSectionHeaderProps>(
  {
    backgroundColor: ClinTheme.colors.white,
    padding: `${ClinTheme.space[3]}px`,
    cursor: 'default',
    margin: '0',
    border: 'none',
    listStyle: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '8px'
  },
  ({ isFirstSection = false }) => ({
    borderTopLeftRadius: isFirstSection ? ClinTheme.radii[3] : 0,
    borderTopRightRadius: isFirstSection ? ClinTheme.radii[3] : 0
  })
)

export const StyledSectionTitle = styled.span({
  fontSize: '18px',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '18px'
})

export const StyledCounterContainer = styled.div({
  display: 'flex',
  padding: '0px 6px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '10px',
  backgroundColor: '#E8E7FF',
  borderRadius: '12px'
})

export const StyledCounterNumber = styled.span({
  color: '#5E5ADB',
  fontSize: '10px',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '16px',
  letterSpacing: '0.3px'
})

export const StyledDesktopWrapper = styled.div({
  width: '100%',
  overflowX: 'auto',
  overflowY: 'auto',
  display: 'none',
  padding: '8px',
  boxSizing: 'border-box',
  maxHeight: '752px',
  [mediaQuery(desktopUpBreakpoint)]: {
    display: 'block'
  }
})

export const StyledLoadingSpinnerWrapper = styled.div({
  textAlign: 'center',
  padding: '0 10px',
  marginTop: 8
})

export const StyledRecentSearchHeader = styled.li({
  backgroundColor: ClinTheme.colors.white,
  padding: `${ClinTheme.space[3]}px ${ClinTheme.space[4]}px`,
  cursor: 'default',
  margin: '0',
  marginBottom: ClinTheme.space[2],
  border: 'none',
  listStyle: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: ClinTheme.space[2],
  borderBottom: `1px solid ${ClinTheme.colors.lightGrey}`,
  borderTopLeftRadius: ClinTheme.radii[3],
  borderTopRightRadius: ClinTheme.radii[3],
  fontSize: ClinTheme.fontSizes[3],
  fontWeight: ClinTheme.fontWeights.normal,
  color: ClinTheme.colors.black,
  // Remove hover effects
  '&:hover, &:focus': {
    border: 'none',
    borderBottom: `1px solid ${ClinTheme.colors.lightGrey}`,
    boxShadow: 'none'
  }
})
